import Dialog from "./Dialog"
import Disclosure from "./DialogDisclosure"

export default Object.assign(Dialog, {
  Disclosure
})
